import { render, staticRenderFns } from "./ComexPedidoLiquidacion.vue?vue&type=template&id=6cd25640"
import script from "./ComexPedidoLiquidacion.vue?vue&type=script&lang=js"
export * from "./ComexPedidoLiquidacion.vue?vue&type=script&lang=js"
import style0 from "./ComexPedidoLiquidacion.vue?vue&type=style&index=0&id=6cd25640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports